import { Loader2Icon } from 'lucide-react';

import { ApiRequestError } from '@/lib/api';
import { ProfileEditProvider } from '@/platform/features/profile/profile-edit-context';
import { ProfileLayout } from '@/platform/layouts/profile-layout';
import { useOwnProfile } from '@/platform/features/users/use-own-profile';

/** Loads own profile once, then renders nested `/profil/*` routes. */
export function ProfilePage() {
  const profile = useOwnProfile();

  if (profile.isPending) {
    return (
      <p className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2Icon className="size-4 animate-spin" aria-hidden />
        Profil wird geladen …
      </p>
    );
  }

  if (profile.isError || !profile.data) {
    return (
      <p role="alert" className="text-sm text-destructive">
        {profile.error instanceof ApiRequestError
          ? profile.error.message
          : 'Das Profil konnte nicht geladen werden.'}
      </p>
    );
  }

  return (
    <ProfileEditProvider profile={profile.data}>
      <ProfileLayout />
    </ProfileEditProvider>
  );
}
